import React from "react";

const BuyAgainSession = () => {
  return (
    <div>
      {/* Componente BuyAgainSession */}
    </div>
  );
};

export default BuyAgainSession;
